import { Spinner, useLoading } from '@/components';
import { useAppContext } from '@/context';
import { useSearchParams } from 'react-router-dom';

export const Generator = () => {
  const { loading } = useLoading();
  const { sessionId } = useAppContext();
  const [searchParams] = useSearchParams();
  const tab = searchParams.get('tab');
  const cid = searchParams.get('cid');

  let url = `https://hook.eu1.make.com/buwxu1225wcsnk2k293pj1njw1l7wioi?sessionId=${sessionId}&hash=4dd5a5e400b724e363662a8f0019b6353e39410e4f746469861be0584b377481`;

  if (tab) {
    url += `&tab=${tab}`;
  }

  if (cid) {
    url += `&cid=${cid}`;
  }

  return loading ? (
    <Spinner fullSize={true} />
  ) : (
    <iframe
      src={url}
      style={{
        border: 'none',
        borderRadius: '6px',
        position: 'absolute',
        top: 0,
        left: 0,
        height: '100%',
        width: '100%',
      }}
    />
  );
};
